import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from "~/components/ui/input-group";

export const PriceInput = ({
  field,
}: {
  field: {
    name: string;
    value: string;
    onChange: (value: string) => void;
    onBlur: () => void;
  };
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;

    // Remove all non-digit and non-decimal characters
    const cleanedValue = rawValue.replace(/[^\d.]/g, "");

    // Split by decimal point - only keep first decimal point
    const parts = cleanedValue.split(".");

    // Handle the integer part (max 3 digits)
    let integerPart = parts[0] ?? "";
    if (integerPart.length > 3) {
      integerPart = integerPart.slice(0, 3);
    }

    // Handle the decimal part (max 2 digits) - only if there's a decimal point
    let formattedValue = integerPart;
    if (parts.length > 1) {
      let decimalPart = parts[1] ?? "";
      if (decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      formattedValue = `${integerPart}.${decimalPart}`;
    }

    field.onChange(formattedValue);
  };

  const handleBlur = () => {
    // Use field.value to ensure we're using the latest state value
    const currentValue = field.value ?? "0.00";

    // Ensure proper format on blur
    const parts = currentValue.split(".");
    const integerPart = parts[0] ?? "0";
    const decimalPart = (parts[1] ?? "00").padEnd(2, "0").slice(0, 2);

    const formattedValue = `${integerPart}.${decimalPart}`;
    field.onChange(formattedValue);
    field.onBlur();
  };

  return (
    <InputGroup>
      <InputGroupAddon align="inline-start">
        <InputGroupText>$</InputGroupText>
      </InputGroupAddon>
      <InputGroupInput
        inputMode="decimal"
        name={field.name}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder="0.00"
        value={field.value}
      />
    </InputGroup>
  );
};
